import { MenuItem, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { ConfirmationDialog } from "components/ConfirmationDialog";
import { useDismissMultipleAlerts } from "hooks/useDismissMultipleAlerts";
import { useFormik } from "formik";
import { map, size } from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Dropdown } from "components/Dropdown";

const validationSchema = Yup.object({
  reason: Yup.string()
    .label("Dismissal reason")
    .required()
    .nullable()
});

export const DismissAlertDialog = ({
  alertsToDismiss,
  open,
  onDismissSuccess,
  onClose
}) => {
  const [error, setError] = useState(false);

  const formik = useFormik({
    initialValues: {
      reason: ""
    },
    validationSchema,
    onSubmit: ({ reason }) => {
      let dismissObject = map(alertsToDismiss, ({ alert_id }) => ({
        reason,
        alert_id: alert_id
      }));
      postDismissMultipleCallback({ items: dismissObject });
    }
  });

  const handleOnComplete = () => {
    setError(false);
    onDismissSuccess();
  };
  const {
    loading,
    error: postError,
    postDismissMultipleCallback
  } = useDismissMultipleAlerts(handleOnComplete);

  useEffect(() => {
    setError(postError);
  }, [postError]);

  return (
    <ConfirmationDialog
      loading={loading}
      error={error}
      title={`Are you sure you want to dismiss ${
        size(alertsToDismiss) > 1 ? "these alerts?" : ` this alert?`
      }`}
      open={open}
      confirmText="confirm"
      onClose={() => {
        setError(false);
        onClose();
      }}
      onConfirm={formik.handleSubmit}
    >
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Dropdown
              id="reason"
              name="reason"
              data-qa="AP-Dismiss-Alert-Dropdown"
              label="Dismissal Reason"
              required
              fullWidth
              value={formik.values.reason}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.reason && Boolean(formik.errors.reason)}
              helperText={formik.touched.reason && formik.errors.reason}
            >
              {dismissalOptions.map(({ id, name }) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
            </Dropdown>
          </Grid>
          {map(alertsToDismiss, alert => (
            <Grid item xs={12} key={alert.alert_id}>
              <Typography variant="h5">{alert.rule_name}</Typography>
              <Typography>
                {alert.machine_name}, {alert.severity_type_name},{" "}
                {alert.site_name}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </form>
    </ConfirmationDialog>
  );
};

DismissAlertDialog.propTypes = {
  alertsToDismiss: PropTypes.array,
  open: PropTypes.bool.isRequired,
  onDismissSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func
};

//Dismissal Dropdown options
const dismissalOptions = [
  {
    id: "irrelevant",
    name: "Not relevant/important"
  },
  {
    id: "resolved",
    name: "Issue already resolved"
  },
  {
    id: "ok",
    name: "Not yet a problem"
  },
  {
    id: "other",
    name: "Other"
  }
];
